import React, { Component } from "react";
import * as FlexLayout from "flexlayout-react";
import Currencies from "./currencies";
import Currency from "./currency";
import { withTranslation } from "react-i18next";

class CurrencyAdmin extends Component {
  LAYOUT = {
    global: {
      minWidth: 100,
      minHeight: 100,
    },
    borders: [],
    layout: {
      type: "row",
      children: [
        {
          type: "tabset",
          weight: 50,
          enableMaximize: false,
          children: [
            {
              type: "tab",
              name: this.props.t("Currencies"),
              enableClose: false,
              component: "Currencies",
            },
          ],
        },
        {
          //Figure out how to make this persistent even when empty.
          type: "tabset",
          id: "1",
          weight: 50,
          enableDeleteWhenEmpty: false,
          enableMaximize: false,
          children: [
            // {
            //   type: "tab",
            //   name: "User",
            //   visible: false,
            //   component: "Placeholder"
            // }
          ],
        },
      ],
    },
  };

  state = {
    model: FlexLayout.Model.fromJson(this.LAYOUT),
  };

  handleCurrencySelect = (Currency, submitCallbackFunction, isNew) => {
    const { currencyId, name } = Currency;

    try {
      this.state.model.doAction(
        FlexLayout.Actions.addNode(
          {
            type: "tab",
            component: "Currency",
            name: `${name}`,
            id: `${currencyId}`,
            config: { currencyId, submitCallbackFunction, isNew },
          },
          "1",
          FlexLayout.DockLocation.CENTER,
          0,
          true
        )
      );
    } catch {
      this.state.model.doAction(FlexLayout.Actions.selectTab(currencyId));
    }
  };

  handleTabRename = (nodeId, name) => {
    this.state.model.doAction(
      FlexLayout.Actions.updateNodeAttributes(nodeId, { name: name })
    );
  };

  factory = (node) => {
    const componentId = node.getComponent();
    //const CurrencyId = node.getId();

    if (componentId === "Currencies") {
      return (
        <Currencies
          onClick={this.handleCurrencySelect}
          allowEdit={this.props.allowEdit}
        />
      );
    } else if (componentId === "Currency") {
      const { currencyId, submitCallbackFunction, isNew } = node.getConfig();
      return (
        <Currency
          currencyId={currencyId}
          submitCallbackFunction={submitCallbackFunction}
          isNew={isNew}
          onRename={this.handleTabRename}
          allowEdit={this.props.allowEdit}
        />
      );
    } else if (componentId === "Placeholder") {
      return <div></div>;
    } else {
      return null;
    }
  };

  buildFlexLayout = () => {
    return (
      <div className="flex-container">
        <FlexLayout.Layout model={this.state.model} factory={this.factory} />;
      </div>
    );
  };

  render() {
    return this.buildFlexLayout();
  }
}

export default withTranslation(["markets"])(CurrencyAdmin);
